
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/document-tools",
      function () {
        return require("private-next-pages/document-tools.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/document-tools"])
      });
    }
  